/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { divideDependencies } from './dependenciesDivide.generated.js';
import { dotDivideDependencies } from './dependenciesDotDivide.generated.js';
import { isNumericDependencies } from './dependenciesIsNumeric.generated.js';
import { logDependencies } from './dependenciesLog.generated.js';
import { mapDependencies } from './dependenciesMap.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { multiplyDependencies } from './dependenciesMultiply.generated.js';
import { sumDependencies } from './dependenciesSum.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createKldivergence } from '../../factoriesAny.js';
export var kldivergenceDependencies = {
  divideDependencies,
  dotDivideDependencies,
  isNumericDependencies,
  logDependencies,
  mapDependencies,
  matrixDependencies,
  multiplyDependencies,
  sumDependencies,
  typedDependencies,
  createKldivergence
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesKldivergence.generated.js
// module id = tErL
// module chunks = 3